export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10058.68654ed9.jpg";